export const VOD_FILE = 'file';
export const VOD_URL = 'url';


export const PLAYBACK_STATUSES = {
    PLAYING: 'playing',
    PAUSED: 'pause',
    STOPPED: 'stop'
};